<script>
import ErrorUtils from './../helpers/ErrorUtils.js';

export default {
  name: 'reservation-form-helpers',
  methods: {
    loadServices () {
      this.$http.post('/panel/services/get-services').then(response => {
        this.servicesCategories = [];
        this.services = [];
        this.allServices = [];
        this.servicesCategories = JSON.parse(JSON.stringify(response.data.categories));
        this.servicesCategories.unshift({
          id: 0,
          name: this.$t('common.ui.services.servicesWithoutCategory'),
          ordering: 0
        });
        this.services = JSON.parse(JSON.stringify(response.data.services));
        this.allServices = JSON.parse(JSON.stringify(response.data.services));
        // this.services = this.services.filter(service => !!service.published);

        if (this.$route.params.worker && this.workersEnabled) {
          let workerID = parseInt(this.$route.params.worker, 10);
          let workerServices = this.workers.filter(worker => worker.id === workerID);

          if (workerServices.length) {
            workerServices = workerServices[0].worker.services.map(service => service.id);
            this.services = this.services.filter(service => workerServices.indexOf(service.id) > -1);
          }
        }

        this.servicesLoaded = true;

        if (this.setServiceAfterFormLoad) {
          this.selectedService = parseInt(this.$route.params.service, 10);
          this.changeService();
        }
      }).catch(error => {
        ErrorUtils.handleLoadError(error, '/panel/services/get-services', this.$router, this.$bus);
      });
    },
    loadWorkers () {
      this.$http.post('/panel/workers/get-workers').then(response => {
        if (this.$route.params.worker) {
          let workerID = parseInt(this.$route.params.worker, 10);
          this.workers = response.data.users.filter(worker => worker.worker_type === 0 && worker.id === workerID);
        } else {
          this.workers = response.data.users.filter(worker => worker.worker_type === 0);
        }

        this.workersLoaded = true;

        if (this.servicesEnabled) {
          this.loadServices();
        }
      }).catch(error => {
        ErrorUtils.handleLoadError(error, '/panel/workers/get-workers', this.$router, this.$bus);
      });
    },
    loadReservationParams (loadPrice = true) {
      this.$http.post('/panel/parameters/get-parameters').then(response => {
        this.reservationParameters = [];
        this.reservationParameters = JSON.parse(JSON.stringify(response.data.parameters));
        this.reservationParameters = this.reservationParameters.filter(param => !!param.published);
        this.parametersLoaded = true;

        if (loadPrice) {
          this.loadPrice();
        }

        setTimeout(() => {
          this.paramsKey = new Date().getTime();
        }, 0);
      }).catch(error => {
        ErrorUtils.handleLoadError(error, '/panel/parameters/get-parameters', this.$router, this.$bus);
        this.parametersLoaded = true;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/ReservationFormHelpers.vue